module.exports = __webpack_public_path__ + "static/media/white_img_c.93893a36.png";